import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  CardText,
  Button,
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap";

import api from "../../../../../../services/api";
import { Canal } from "../../../../../../entities/Marketing";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { NovoCanalModal } from "./modals/NovoCanalModal";
import { ConectarPlayneeConversasModal } from "./modals/ConectarPlayneeConversasModal";
import { useGoogleLogin } from "@react-oauth/google";
import { CanalCard } from "./components/cards";
import AuthContext from "../../../../../../contexts/Auth";
import QRCode from "qrcode.react";
import { useWhatsappContext } from "../../../../../../contexts/Whatsapp";
import { IAccount } from "../../../../../marketing/Chat/types";
import EmpresaContext from "../../../../../../contexts/Empresa";

interface ClientInfoResponse {
  success: boolean;
  sessionInfo: {
    pushname: string;
    wid: {
      server: string;
      user: string;
      _serialized: string;
    };
    me: {
      server: string;
      user: string;
      _serialized: string;
    };
    platform: string;
  };
}

export interface CanalVenda extends Canal {
  color: string;
  icon: string;
  is_canal_contato: boolean;
}

export interface CanalContato {
  canal: CanalVenda;
  identificador: string;
  is_canal_contato: boolean;
}

export interface ModeloSite {
  id: number;
  link: string;
  tipo_modelo: "vendedor" | "indicacao";
  params_map: string;
}

interface ParametroSite {
  id: number;
  chave: string;
  valor: string;
  descricao: string;
  usuario_modelo_site_id: string;
}

export interface UsuarioModeloSite {
  id: string;
  user_empresa_id: number;
  modelo_site_id: number;
  parametroSite: ParametroSite[];
  site: ModeloSite;
}

type SessionStatusData = {
  sessionId: string;
  phoneNumber?: string;
  isConnected: boolean;
  hasQR: boolean;
};

type SessionStatusResponse =
  | { success: true; data: SessionStatusData }
  | { success: false; message?: string };

export function Canais() {
  const { user } = useContext(AuthContext);
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [canaisDeVenda, setCanaisDeVenda] = useState<CanalVenda[] | null>(null);
  const [canaisContato, setCanaisContato] = useState<CanalContato[] | null>(
    null,
  );

  const [canalSelecionado, setCanalSelecionado] = useState<string | undefined>(
    undefined,
  );
  const [isEmailSync, setIsEmailSync] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState<any>(null);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalPlayneeConversas, setModalPlayneeConversas] = useState(false);
  const [numeroPlayneeSelecionado, setNumeroPlayneeSelecionado] = useState<string | null>(null);
  const [refreshPlayneeKey, setRefreshPlayneeKey] = useState(0);

  const togglePlayneeConversas = (numero?: string) => {
    if (numero) setNumeroPlayneeSelecionado(numero);
    setModalPlayneeConversas((prev) => !prev);
  }

  const modalOpenRef = useRef(false);

  const handleCloseModal = () => setModal(false);

  const [modalWhatsApp, setModalWhatsApp] = useState(false);
  const [QRCodeString, setQRCodeString] = useState("");
  const [compartilharConversas, setCompartilharConversas] = useState({
    whatsapp: false,
    instagram: false,
  });
  const [sessionID, setSessionID] = useState("");
  const [isSessionActive, setIsSessionActive] = useState({
    whatsapp: false,
    instagram: false,
  });
  const [userWhatsAppAccount, setUserWhatsAppAccount] =
    useState<IAccount | null>();
  const [baileysUrl, setBaileysUrl] = useState<string | null>(null);

  const canaisDisponiveis = useMemo(() => {
    return canaisDeVenda?.filter(
      (canal) =>
        !canaisContato?.some((contato) => canal.id == contato.canal.id),
    );
  }, [canaisContato, canaisDeVenda]);

  async function carregarCanaisDeVenda() {
    try {
      setIsLoading(true);
      const { data } = await api.get<CanalVenda[]>(`/marketing/canais`);

      setCanaisDeVenda(data.filter((canal) => canal.is_canal_contato));
    } catch (error) {
      console.error(
        "Houve um erro ao tentar carregar os canais de venda.",
        error,
      );
    } finally {
      setIsLoading(false);
    }
  }

  function launchWhatsAppSignup() {
    //@ts-ignore
    FB.login(
      function (response: any) {
        if (response.authResponse) {
          const code = response.authResponse.code;
          api
            .post("/meta/access-token", { code, userId: user?.id })
            .catch((err) => console.error(err));
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: process.env.REACT_APP_FB_LOGIN_CONFIG_ID,
        response_type: "code", // must be set to 'code' for System User access token
        override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
        extras: JSON.stringify({
          featureType: "whatsapp_business_app_onboarding",
          sessionInfoVersion: "3",
          version: "v4",
        }),
      },
    );
  }

  async function carregarWhatsAppUserAccount() {
    const { data: accounts } = await api.get<IAccount[]>(
      `/meta/all-accounts/user?userId=${user?.id}`,
    );

    if (accounts) {
      const foundAccounts = accounts.filter(
        (account) => account.user_id === user?.id && account.situacao === "A",
      );

      console.log({ foundAccounts });

      foundAccounts.map((account) => {
        if (account.provider === "whatsapp") {
          setUserWhatsAppAccount(account);
          setIsSessionActive({ ...isSessionActive, whatsapp: true });
          setCompartilharConversas({
            ...compartilharConversas,
            whatsapp: account.compartilhar_conversas,
          });
        }

        if (account.provider === "instagram") {
          setUserWhatsAppAccount(account);
          setIsSessionActive({ ...isSessionActive, instagram: true });
          setCompartilharConversas({
            ...compartilharConversas,
            instagram: account.compartilhar_conversas,
          });
        }
      });
    }
  }

  function handleSaveNovoCanal({ canalSelecionado, identificador }: any) {
    createCanalContato(canalSelecionado, identificador);
  }

  useEffect(() => {
    carregarCanaisDeVenda();
    getCanaisContato();
    checkIfEmailIsSynchronized();
    carregarWhatsAppUserAccount();
    findDedicatedBaileysIntegration();
  }, []);

  async function checkIfEmailIsSynchronized() {
    const { data } = await api.get<boolean>(
      `marketing/agendamentos/auth/google`,
    );
    setIsEmailSync(data);
  }

  async function getCanaisContato() {
    try {
      setIsLoading(true);
      const { data } = await api.get(`/marketing/me/canais-contato`);

      setCanaisContato(data);
    } catch (error) {
      console.error(
        "Houve um erro ao tentar listar os canais de contato.",
        error,
      );
    } finally {
      setIsLoading(false);
    }
  }

  async function createCanalContato(
    canalId: string | number,
    identificador: string,
  ) {
    try {
      setIsLoading(true);
      const { data } = await api.post(`/marketing/me/canais-contato`, {
        identificador:
          // canalId == '25' ? identificador.replace(/\D/g, '') : identificador,
          identificador,
        canal_id: canalId,
      });

      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Canal de contato criado com sucesso!
        </ReactBSAlert>,
      );

      getCanaisContato();
      checkIfEmailIsSynchronized();
      handleCloseModal();

      return data;
    } catch (error) {
      console.error(
        "Houve um erro ao tentar criar um canal de contato.",
        error,
      );
    } finally {
      setIsLoading(false);
    }
  }

  function handleVisibilidadeCanalContato(
    canalId: string | number,
    isVisible: boolean,
  ) {
    // console.log({ canalId, isVisible })
    // TODO send to db
  }

  function handleDeleteCanalContato(canalId: string | number) {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title="Tem certeza que deseja remover o contato?"
        onConfirm={() => deleteCanalContato(canalId)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
        confirmBtnText="Sim"
        btnSize=""
        showCancel
        focusCancelBtn
      />,
    );
  }

  async function terminateWhatsAppSession(
    sessionId: string,
    accountId: string,
  ) {
    await api.post(
      `/meta/terminate`,
      {
        session_id: sessionId,
        account_id: accountId,
      },
      { timeout: 15000 },
    );

    setAlert(null);
  }

  async function deleteCanalContato(canalId: string | number) {
    try {
      await api.delete(`/marketing/me/canais-contato/${canalId}`);

      if (canalId == 25 && userWhatsAppAccount) {
        const { id, session_id } = userWhatsAppAccount;
        terminateWhatsAppSession(session_id, id);
      }

      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Canal de contato removido com sucesso!
        </ReactBSAlert>,
      );

      getCanaisContato();
    } catch (error) {
      console.error(
        "Houve um erro ao tentar remover um canal de contato.",
        error,
      );
    }
  }

  const temCanais = canaisDisponiveis && canaisDisponiveis.length > 0;

  const formatPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber.length <= 10) {
      return `(${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2, 6)}-${phoneNumber.slice(6, 10)}`;
    } else {
      return `(${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2, 7)}-${phoneNumber.slice(7, 11)}`;
    }
  };

  const formatSocialsLink = (text: string) => {
    return text.split(".com")[1];
  };

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    scope:
      "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.email",
    onSuccess: async (codeResponse) => {
      setIsLoading(true);
      const googleResponse = await api.post(
        "marketing/agendamentos/auth/google",
        {
          code: codeResponse.code,
        },
      );
      createCanalContato(12, googleResponse.data.userEmail);

      setIsEmailSync(true);
      setIsLoading(false);
      handleCloseModal();
    },
    onError: (errorResponse) => console.log(errorResponse),
  });

  function toggleWhatsAppModal() {
    modalOpenRef.current = !modalOpenRef.current;
    setModalWhatsApp((currentState) => !currentState);
  }

  function handleModalClose() {
    modalOpenRef.current = false;
    setModalWhatsApp(false);
    setQRCodeString("");
  }

  async function startSession() {
    try {
      const { data } = await api.get(`/meta/start`, {
        timeout: 10000,
      });
      setSessionID(data.id);

      console.log(
        "",
        `${new Date().toLocaleString()} - Sessão ${data.id} iniciada.`,
      );
      return data;
    } catch (error) {
      window.alert(
        "Ocorreu um erro ao tentar gerar o QR code. Tente novamente em alguns minutos.",
      );
      console.error(error);
    }
  }

  const CONNECT_POLL_INTERVAL_MS = 30000;
  const CONNECT_TIMEOUT_MS = 120000;

  const QR_POLL_INTERVAL_MS = 1500;
  const QR_TIMEOUT_MS = 60000;

  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  const statusTimerRef = { current: null as any };

  function showSuccess(
    setAlert: (n: any) => void,
    title: string,
    body?: React.ReactNode,
  ) {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block" }}
        title={title || "Sucesso!"}
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="primary"
        confirmBtnText="Ok"
        btnSize=""
      >
        {body || null}
      </ReactBSAlert>,
    );
  }

  async function waitForQRCode(
    API_BAILEYS_URL: string,
    sessionId: string,
  ): Promise<{ ok: true; qr: string } | { ok: false; reason: string }> {
    const deadline = Date.now() + QR_TIMEOUT_MS;
    let lastError = "QR não gerado a tempo.";

    while (Date.now() < deadline) {
      try {
        const res = await fetch(`${API_BAILEYS_URL}/sessions/${sessionId}/qr`);
        if (res.ok) {
          const qrData = await res.json();
          if (qrData?.success && qrData?.qrCode) {
            return { ok: true, qr: qrData.qrCode };
          }
          // 200 sem qrCode => ainda não pronto; continua tentando
          lastError = "QR ainda não disponível.";
        } else if (res.status === 404 || res.status === 204) {
          // Normal enquanto o QR não foi gerado; só aguardar e tentar de novo
          lastError = `Aguardando geração do QR (${res.status}).`;
        } else {
          lastError = `Falha ao consultar QR (HTTP ${res.status}).`;
        }
      } catch (e: any) {
        lastError = e?.message || "Erro de rede ao buscar o QR.";
      }

      await sleep(QR_POLL_INTERVAL_MS);
    }

    return { ok: false, reason: lastError };
  }

  function showError(
    setAlert: (n: any) => void,
    title: string,
    body?: React.ReactNode,
  ) {
    setAlert(
      <ReactBSAlert
        error
        style={{ display: "block" }}
        title={title || "Falha!"}
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="primary"
        confirmBtnText="Ok"
        btnSize=""
      >
        {body || null}
      </ReactBSAlert>,
    );
  }

  /**
   * Monitora a sessão até conectar ou estourar o timeout.
   * - Faz GET `${API_BAILEYS_URL}/sessions/:id`
   * - Para quando `isConnected === true`
   * - Erra se passar de CONNECT_TIMEOUT_MS
   */
  async function waitForConnection(
    API_BAILEYS_URL: string,
    sessionId: string,
  ): Promise<{ ok: true; phone?: string } | { ok: false; reason: string }> {
    const deadline = Date.now() + CONNECT_TIMEOUT_MS;
    let lastError = "Tempo esgotado ao tentar conectar.";

    while (Date.now() < deadline) {
      try {
        const res = await fetch(`${API_BAILEYS_URL}/sessions/${sessionId}`);
        if (!res.ok) {
          lastError = `Status HTTP ${res.status}`;
        } else {
          const json = (await res.json()) as SessionStatusResponse;

          if (json.success && json.data) {
            // Conectado?
            if (json.data.isConnected) {
              return { ok: true, phone: json.data.phoneNumber };
            }
          } else {
            lastError = (json as any).message || "Sessão não encontrada.";
          }
        }
      } catch (e: any) {
        lastError =
          e?.message || "Erro de rede ao consultar o estado da sessão.";
      }

      await new Promise((r) => setTimeout(r, CONNECT_POLL_INTERVAL_MS));
    }

    return { ok: false, reason: lastError };
  }

  async function findDedicatedBaileysIntegration() {
    const response = await api.get(
      `esb/integracoes/ativas?types[]=whatsapp&empresaId=${empresaSelecionada?.id}`,
    );

    let dedicatedUrl = null;
    if (response.data[0]) {
      dedicatedUrl = response.data[0].valor;
    }

    dedicatedUrl && setBaileysUrl(dedicatedUrl);
  }

  /**
   * - criação de sessão
   * - busca única do QR
   * - monitoramento do estado até conectar ou timeout
   * - alerts de sucesso/erro no padrão do seu código
   */
  async function fetchQRCode(
    setIsLoading: (b: boolean) => void,
    setAlert: (n: any) => void,
    setSessionID: (id: string) => void,
    setQRCodeString: (s: string) => void,
  ) {
    const API_BAILEYS_URL = baileysUrl;

    if (!API_BAILEYS_URL) {
      console.error(
        "Erro: Variável de ambiente REACT_APP_API_BAILEYS_URL não configurada.",
      );
      showError(
        setAlert,
        "Falha!",
        "Erro de configuração: URL da API do Baileys não encontrada.",
      );
      return;
    }

    // Se houver um timer antigo rodando, cancela
    if (statusTimerRef.current) {
      clearTimeout(statusTimerRef.current);
      statusTimerRef.current = null;
    }

    setIsLoading(true);

    try {
      // 1) Cria sessão
      const response = await fetch(`${API_BAILEYS_URL}/sessions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          empresa_id: empresaSelecionada?.id,
        }),
      });
      const data = await response.json();

      if (!data?.success || !data?.sessionId) {
        showError(
          setAlert,
          "Falha!",
          "Não foi possível criar a sessão. Tente novamente.",
        );
        return;
      }

      const sessionId: string = data.sessionId;
      setSessionID(sessionId);

      // 2) Aguarda o QR ficar pronto (retry controlado, sem setInterval)
      const qrResult = await waitForQRCode(API_BAILEYS_URL, sessionId);
      if (qrResult.ok) {
        setQRCodeString(qrResult.qr);
      } else {
        showError(
          setAlert,
          "Falha!",
          qrResult.reason ||
            "Não foi possível obter o QR Code. Tente criar a sessão novamente.",
        );
        return;
      }

      // 3) Monitora o estado até conectar ou time out (já estava pronto)
      const result = await waitForConnection(API_BAILEYS_URL, sessionId);

      if (result.ok) {
        showSuccess(
          setAlert,
          "Conectado!",
          result.phone
            ? `Sessão vinculada ao número ${result.phone}.`
            : "Sessão conectada com sucesso.",
        );
      } else {
        showError(
          setAlert,
          "Falha!",
          result.reason ||
            "A sessão não conectou a tempo. Recarregue o QR Code e tente novamente (o QR expira em poucos segundos).",
        );
      }
    } catch (error) {
      console.error("Erro ao iniciar sessão/QR do Baileys:", error);
      showError(setAlert, "Falha!", "Erro ao falar com o servidor Baileys.");
    } finally {
      setIsLoading(false);
    }
  }

  // async function checkSessionStatus(sessionId: string) {
  // 	try {
  // 		const { data } = await api.get<SessionStatusResponse>(`/meta/status?session_id=${sessionId}`, { timeout: 10000 })
  // 		if (data && data.success) {
  // 			const conectado = Boolean(data.data?.isConnected)
  // 			setIsSessionActive(conectado)
  // 			setSessionID(sessionId)
  // 			return conectado
  // 		} else {
  // 			console.warn(`[${new Date().toLocaleString()}] ⚠️ Sessão não encontrada ou inválida:`, data)
  // 			setIsSessionActive(false)
  // 			return false
  // 		}
  // 	} catch (error) {
  // 		console.error(`[${new Date().toLocaleString()}] ❌ Erro ao consultar sessão ${sessionId}:`, error)
  // 		setIsSessionActive(false)
  // 		return false
  // 	}
  // }

  // async function handleShareChatChange(event: React.ChangeEvent<HTMLInputElement>) {
  // 	try {
  // 		const compartilharConversasCheck = event.target.checked

  // 		if (userWhatsAppAccount) {
  // 			// api call para mudança do checkmark
  // 			await api.put(`/meta/accounts/${userWhatsAppAccount.id}/share`, {
  // 				compartilhar_conversas: compartilharConversasCheck,
  // 			})
  // 		}

  // 		setCompartilharConversas(compartilharConversasCheck)
  // 	} catch (error) {
  // 		console.error(error)
  // 	}
  // }

  async function getClientInfo(sessionId: string) {
    try {
      console.log(
        `${new Date().toLocaleString()} - Buscando status da conexão com o WhatsApp.`,
      );
      const {
        data: { success },
      } = await api.get(`/meta/status?session_id=${sessionId}`);

      if (success) {
        console.log(
          `${new Date().toLocaleString()} - Número conectado, buscando informações do número.`,
        );
        const {
          data: { sessionInfo },
        } = await api.get<ClientInfoResponse>(
          `/meta/class-info?session_id=${sessionId}`,
        );

        console.log(
          `${new Date().toLocaleString()} - Informações do número encontradas, salvando Account.`,
        );

        const {
          wid: { user: numeroConectado },
        } = sessionInfo;

        const { pushname } = sessionInfo;
        // Se os dados da sessão existirem, registra a conta no sistema
        await api.post(`/meta/accounts/web`, {
          account: {
            verified_name: pushname,
            code_verification_status: "VERIFIED",
            display_phone_number: numeroConectado,
            quality_rating: "GREEN",
            id: numeroConectado,
            session_id: sessionID,
            compartilhar_conversas: compartilharConversas,
          },
        });

        // Exibe o alerta de sucesso e fecha o modal
        setAlert(
          <ReactBSAlert
            success
            style={{ display: "block" }}
            title="Sucesso!"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="primary"
            confirmBtnText="Ok"
            btnSize=""
          >
            Número sincronizado com sucesso!
          </ReactBSAlert>,
        );
        setModalWhatsApp(false); // Fechar o modal
        setQRCodeString("");
        // Retorna verdadeiro para parar o polling
        return true;
      }
    } catch (error) {
      console.error("Erro ao obter informações do cliente:", error);
    }

    // Retorna falso para continuar o polling
    return false;
  }

  useEffect(() => {
    let pollingInterval: NodeJS.Timeout | undefined;

    if (QRCodeString && sessionID) {
      // Quando a imagem do QR Code for exibida, inicia o polling
      pollingInterval = setInterval(async () => {
        const isClientSynced = await getClientInfo(sessionID);

        if (isClientSynced) {
          // Se a conta for sincronizada, para o polling
          clearInterval(pollingInterval);
        }
      }, 3000);
    }

    // Limpa o polling se o componente for desmontado
    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [QRCodeString, sessionID]);

  return (
    <>
      {/* <Modal isOpen={modalWhatsApp} toggle={handleModalClose}>
				<ModalHeader>Meu WhatsApp</ModalHeader>
				<ModalBody>
					<Alert color="primary text-center">
						<strong>Atenção: utilize essa função para números comerciais.</strong>
						<br />
						Ao ler o QR code, o seu número comercial estará conectado exclusivamente ao seu perfil de usuário do Playnee.
						Ninguém além de você será capaz de ler as mensagens trocadas com seus clientes. Marque a opção “Compartilhar
						conversas com minha liderança“, caso queira que sua liderança possa visualizar tais informações.
					</Alert>

					{isLoading && (
						<div className="d-flex justify-content-center align-items-center" style={{ gap: "1rem" }}>
							<span>Gerando seu QR Code...</span>
							<Spinner color="primary" size="sm" />
						</div>
					)}
					{QRCodeString && (
						<div className="text-center mb-3">
							<img src={QRCodeString} alt="QR Code" />
						</div>
					)}
					<FormGroup className="text-center mb-0">
						<Input
							id="shareChat"
							name="shareChat"
							type="checkbox"
							checked={compartilharConversas}
							onChange={handleShareChatChange}
						/>
						<Label className="form-control-label" for="shareChat">
							Compartilhar conversas com a minha liderança
						</Label>
					</FormGroup>
				</ModalBody>
				{isSessionActive && (
					<Badge style={{ margin: "0 auto", width: "min-content" }} color="success">
						Conectado
					</Badge>
				)}
				{!isSessionActive && (
					<Badge style={{ margin: "0 auto", width: "min-content" }} color="danger">
						Desconectado
					</Badge>
				)}
				<ModalFooter>
					<Button outline onClick={handleModalClose}>
						Voltar
					</Button>

					{!isSessionActive && (
						<Button
							color="primary"
							disabled={isLoading}
							onClick={() => fetchQRCode(setIsLoading, setAlert, setSessionID, setQRCodeString)}
						>
							Iniciar Sessão
						</Button>
					)}
					{isSessionActive && userWhatsAppAccount && (
						<Button
							color="danger"
							onClick={() => terminateWhatsAppSession(userWhatsAppAccount.session_id, userWhatsAppAccount.id)}
						>
							Desconectar
						</Button>
					)}
				</ModalFooter>
			</Modal> */}
      {alert}
      {temCanais && (
        <NovoCanalModal
          isOpen={modal}
          onClose={handleCloseModal}
          onSave={handleSaveNovoCanal}
          canais={canaisDisponiveis}
          isLoading={isLoading}
          googleLogin={googleLogin}
        />
      )}
      <ConectarPlayneeConversasModal
        isOpen={modalPlayneeConversas}
        onClose={() => {
          setModalPlayneeConversas(false);
          setNumeroPlayneeSelecionado(null);
        }}
        onConnected={() => {
          getCanaisContato();
          setRefreshPlayneeKey(prev => prev + 1);
        }}
        numeroAtual={numeroPlayneeSelecionado}
      />
      <Row className="align-items-center mb-3">
        <Col>
          <h2 className="mb-0">Meus canais de contato</h2>
        </Col>
      </Row>
      <Row>
        {temCanais && (
          <Col xs={12} sm={6} md={4} lg={3}>
            <Card
              style={{
                background: "#eee",
                height: "400px",
                border: "2px dashed",
              }}
            >
              <CardBody
                className="d-flex align-items-center justify-content-center flex-column"
                onClick={toggle}
                role="button"
                style={{ cursor: "pointer" }}
              >
                <CardText className="font-weight-bold">
                  <span>
                    <i className="fas fa-plus" />
                  </span>
                </CardText>
                <CardText className="font-weight-bold">Novo Canal</CardText>
              </CardBody>
            </Card>
          </Col>
        )}

        {canaisContato?.map((item) => (
          <CanalCard
            openWAModal={toggleWhatsAppModal}
            isConversasSync={isSessionActive}
            canal={item.canal}
            googleLogin={googleLogin}
            identificador={item.identificador}
            isEmailSync={isEmailSync}
            onChangePrivacy={handleVisibilidadeCanalContato}
            onDelete={handleDeleteCanalContato}
            key={item.canal.id}
            is_canal_contato
            baileysUrl={baileysUrl}
            onConnectCoexistence={launchWhatsAppSignup}
            onConnectPlayneeConversas={togglePlayneeConversas}
            refreshKey={refreshPlayneeKey}
          />
        ))}
      </Row>
    </>
  );
}
